import { render, staticRenderFns } from "./OnlyReadDetails.vue?vue&type=template&id=d7e55480&scoped=true"
import script from "./OnlyReadDetails.vue?vue&type=script&lang=js"
export * from "./OnlyReadDetails.vue?vue&type=script&lang=js"
import style0 from "./OnlyReadDetails.vue?vue&type=style&index=0&id=d7e55480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e55480",
  null
  
)

export default component.exports